import React, { useEffect, useState } from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, useNotify, Loading, Error } from 'react-admin'
import { Grid, Container, Skeleton, Chip, Typography } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { clientServices } from 'src/services/auth/client/client.service'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>
const ShowContent = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const [loadingAllApplicationByClient, setLoadingApplicationByClient] = useState(false)
  const [applicationSelect, setApplicationSelect] = useState([])
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  useEffect(() => {
    if (record?.id) {
      ;(async () => {
        try {
          setLoadingApplicationByClient(true)
          const allApplicationByClient = await clientServices.getApplicationByClient(record?.id)
          if (allApplicationByClient) {
            setApplicationSelect(
              allApplicationByClient.map((item) => {
                return {
                  short_name: item.application.short_name,
                  id: item.application.id,
                }
              })
            )
            setLoadingApplicationByClient(false)
            return
          }
          notify(`applications not found`, { type: 'error' })
          setLoadingApplicationByClient(false)
        } catch (error) {
          notify(`please, refresh page`, { type: 'error' })
          setLoadingApplicationByClient(false)
        }
      })()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={translate('ra.entity.client')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={translate('ra.field.id')} value={record.id} />
          <ShowListElement label={translate('ra.field.long_name')} value={record.long_name} />
          <ShowListElement label={translate('ra.field.short_name')} value={record.short_name} />
          <ShowListElement label={translate('ra.field.is_active')} value={record.is_active} type='boolean' />
          {loadingAllApplicationByClient ? (
            <Grid item xs={12} sm={4} className='uiShowListElement'>
              <Skeleton variant='rectangular' width={'100%'} height={40} />
            </Grid>
          ) : (
            <Grid item xs={12} sm={4} className='uiShowListElement'>
              <Typography className='keyText' component='span' color='text.primary'>
                {translate('ra.field.application')}:
              </Typography>
              <div className='valueText' component='span' color='text.primary'>
                {applicationSelect?.map((item) => (
                  <Chip key={item.id} label={item.short_name} variant='outlined' />
                ))}
              </div>
            </Grid>
          )}
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const ClientShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
